import React from 'react'

export const rhodeIslandSetupVars = {
  siteId: 'rhode_island',
  pathPrefix: '/ri',
  menuHeader: "Discover Rhode Island's Solution for:",
  appUrl: 'https://ri.headed2.com',
  logoImg: '/images/assets/rhode_island/horizontal/dark.svg',
  headerTitle: `The Rhode Island CareerExplorer is a system designed for Rhode Island`
}
